<template>
  <div class="available-cubes content">
    <a href="/" class="logo">
      <img :src="assetsPath('logo.svg')" />
    </a>
    <h1 v-if="showSelection()" class="available-cubes__title">
      {{ str('availableCubes.title') }}
    </h1>
    <div v-else>Loading</div>
    <ul v-if="showSelection()" class="available-cubes__list">
      <li
        :key="cube.cubeName"
        v-for="cube in $store.getters.availableCubes"
        class="available-cubes__item"
      >
        <a
          class="available-cubes__link"
          @click.prevent="$store.dispatch('selectCube', cube.cubeName)"
        >
          <img class="available-cubes__img" :src="cubeIconUrl(cube)" />
          <h4 class="available-cubes__cube-title">{{ cube.nickName }}</h4>
        </a>
      </li>
    </ul>

    <div class="available-cubes__logout">
      <a @click="$store.dispatch('logoutUser')">Abmelden</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'select-cube',
    mounted() {
      if (this.$store.getters.isCubeSelected) {
        this.$router.push({
          name: 'home',
        })
      }
    },
    methods: {
      showSelection() {
        return this.$store.getters.availableCubes.length > 0
      },
      cubeIconUrl: function (rawCube) {
        const cube = {
          cubeName: rawCube.cubeName,
          // Since we don't have more info about the cubes at this point (yet)
          // we only show a generic image.
          hasProduction: false,
        }
        return this.$store.getters.cubeIconUrl(cube, 'svg')
      },
    },
  }
</script>

<style lang="scss">
  .available-cubes {
    max-width: 400px;
    margin: spacer(3) auto;

    .logo {
      display: block;
      margin-left: auto;
      margin-right: auto;
      margin-top: 5vh;
    }

    &__title {
      font-size: $font-size-lg;
      font-weight: $font-weight-base;
      text-align: center;
      transition: $transition-base;
      padding: 0 spacer(1);
      line-height: $line-height-sm;

      @media (min-width: $bp-ssm) {
        margin-top: spacer(4);
        margin-bottom: spacer(2);
      }
    }

    &__list {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    &__item {
      margin: 0 spacer(0.5) 0;

      @media (min-width: $bp-ssm) {
        margin-bottom: spacer(0.5);
      }

      &:last-child {
        border-bottom: none;
      }
    }

    &__link {
      cursor: pointer;
      padding: 0;
      display: flex;
      align-items: center;
    }

    &__img {
      padding: 0;
      max-width: 50px;
      margin-right: spacer(0.5);
      flex-shrink: 0;

      @media (min-width: $bp-ssm) {
        max-width: 70px;
      }
    }

    &__cube-title {
      margin: 0;
      font-size: $font-size-lg;
      line-height: $line-height-min;
      transition: $transition-base;
      font-weight: normal;

      @media (min-width: $bp-ssm) {
        font-size: $font-size-xl;
      }
    }

    &__logout {
      margin-top: spacer(4);
      text-align: center;
    }
  }
</style>
